import { CommonModule } from '@angular/common';
import { Component, computed, input, output } from '@angular/core';

@Component({
  selector: 'app-tenant-inactive-modal',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './tenant-inactive-modal.component.html',
  styleUrl: './tenant-inactive-modal.component.scss',
})
export class TenantInactiveModalComponent {
  readonly visible = input(false);
  readonly tenantName = input<string | null>(null);
  readonly supportEmail = input('support@worxstax.com');
  readonly dismissed = output<void>();

  readonly displayTenant = computed(() => {
    const name = (this.tenantName() ?? '').trim();
    return name ? name : 'Your Account';
  });

  mailtoHref(): string {
    const email = (this.supportEmail() ?? '').trim() || 'support@worxstax.com';
    return `mailto:${encodeURIComponent(email)}?subject=${encodeURIComponent('Account Inactive')}`;
  }
}

